import React from 'react';
import Immagine from '../../components/Immagine/Immagine';

const Logo  = () => {

    return (
        <div>
            <Immagine urlImage={'new.svg'} name='PrestiPay' />
        </div>
    )
}

export default Logo;